import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  isLoading = new Subject<boolean>();

  constructor() { }

  show(){
    console.log("show",this.isLoading);
    this.isLoading.next(true);
  }

  hide(){
    console.log("hide",this.isLoading);
    this.isLoading.next(false);
  }

}
